// Branch content. One shared template (`BranchPage`) renders these.

export const BRANCHES = [
  {
    slug: "ludhiana",
    city: "Ludhiana",
    region: "Punjab, India",
    isHead: true,
    tagline: "Head office",
    headline: "VisaXpert · Ludhiana",
    sub: "Our flagship office in the heart of Punjab. Walk in for full-spectrum study-abroad and visa support.",
    address: "Address coming soon · Ludhiana, Punjab, India",
    phone: "+91 98759 85641",
    email: "ludhiana@visaxpert.in",
    hours: [
      { day: "Monday – Saturday", time: "10:00 AM – 7:00 PM" },
      { day: "Sunday",             time: "By appointment" },
    ],
    services: ["Counselling", "University application", "Visa filing", "IELTS coaching", "Pre-departure briefings"],
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27460.456!2d75.85!3d30.91!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2sLudhiana!5e0!3m2!1sen!2sin!4v1700000000000",
  },
  {
    slug: "amritsar",
    city: "Amritsar",
    region: "Punjab, India",
    tagline: "Walk-in counselling",
    headline: "VisaXpert · Amritsar",
    sub: "Counselling-focused branch close to the airport — perfect for in-person intake reviews.",
    address: "Address coming soon · Amritsar, Punjab, India",
    phone: "+91 98759 85641",
    email: "amritsar@visaxpert.in",
    hours: [{ day: "Monday – Saturday", time: "10:00 AM – 7:00 PM" }],
    services: ["Counselling", "University application", "IELTS coaching"],
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27200!2d74.87!3d31.63!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2sAmritsar!5e0!3m2!1sen!2sin!4v1700000000001",
  },
  {
    slug: "jammu",
    city: "Jammu",
    region: "J&K, India",
    tagline: "Visa documentation hub",
    headline: "VisaXpert · Jammu",
    sub: "Documentation-led branch serving students across Jammu & Kashmir.",
    address: "Address coming soon · Jammu, J&K, India",
    phone: "+91 98759 85641",
    email: "jammu@visaxpert.in",
    hours: [{ day: "Monday – Saturday", time: "10:00 AM – 6:30 PM" }],
    services: ["Counselling", "Visa filing", "Document compilation"],
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27000!2d74.85!3d32.73!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2sJammu!5e0!3m2!1sen!2sin!4v1700000000002",
  },
  {
    slug: "pathankot",
    city: "Pathankot",
    region: "Punjab, India",
    tagline: "Border-region hub",
    headline: "VisaXpert · Pathankot",
    sub: "Covering students from Pathankot, Gurdaspur, Kangra and Hoshiarpur belts.",
    address: "Address coming soon · Pathankot, Punjab, India",
    phone: "+91 98759 85641",
    email: "pathankot@visaxpert.in",
    hours: [{ day: "Monday – Saturday", time: "10:00 AM – 6:30 PM" }],
    services: ["Counselling", "University application", "Visa filing"],
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27300!2d75.65!3d32.27!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2sPathankot!5e0!3m2!1sen!2sin!4v1700000000003",
  },
  {
    slug: "berlin",
    city: "Berlin",
    region: "Germany",
    flag: "🇩🇪",
    tagline: "On-ground in Germany",
    headline: "VisaXpert · Berlin",
    sub: "Our European office — supporting students after they land. Housing, registration, jobs, university transfer.",
    address: "Belziger Strasse 69-71, 10823 Berlin, Germany",
    phone: "+49 1784 555 932",
    email: "berlin@visaxpert.in",
    hours: [
      { day: "Monday – Friday", time: "09:30 AM – 6:30 PM CET" },
      { day: "Saturday",         time: "By appointment" },
    ],
    services: ["Post-arrival housing", "Anmeldung & visa extension", "University change", "Job search support"],
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2429.45!2d13.346!2d52.488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2sBelziger+Strasse+69-71+10823+Berlin!5e0!3m2!1sen!2sde!4v1700000000004",
  },
];

export const BRANCH_BY_SLUG = Object.fromEntries(BRANCHES.map((b) => [b.slug, b]));
